import {withTranslation} from 'react-i18next';
import {SvgIcon} from '../../common/SvgIcon';

import {
    FooterSection,
    FooterWrapper,
    FooterTop,
    FooterBrand,
    FooterDescription,
    FooterColumns,
    FooterColumn,
    ColumnTitle,
    FooterLink,
    FooterBottom,
    Copyright,
    FooterLegal,
    SocialLinks,
    LogoContainer,
} from './styles';

const Footer = () => {
    const scrollTo = (id: string) => {
        const element = document.getElementById(id) as HTMLDivElement;
        if (element) {
            element.scrollIntoView({behavior: 'smooth'});
        }
    };

    return (
        <FooterSection>
            <FooterWrapper>
                <FooterTop>
                    <FooterBrand>
                        <LogoContainer>
                            <SvgIcon
                                src="open.svg"
                                aria-label="OpenDaara"
                                width="180px"
                                height="120px"
                            />
                        </LogoContainer>
                        <FooterDescription>
                            La plateforme cloud moderne pour simplifier la gestion de votre Daara et Dahira.
                        </FooterDescription>
                        <SocialLinks>
                            <a href="https://twitter.com/ferlotechnology" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                                <SvgIcon src="twitter.svg" width="18px" height="18px"/>
                            </a>
                            <a href="https://www.linkedin.com/in/ferlotechnology/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                <SvgIcon src="linkedin.svg" width="18px" height="18px"/>
                            </a>
                            <a href="https://instagram.com/@ferlotechnology/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                <SvgIcon src="medium.svg" width="18px" height="18px"/>
                            </a>
                        </SocialLinks>
                    </FooterBrand>

                    <FooterColumns>
                        <FooterColumn>
                            <ColumnTitle>Produit</ColumnTitle>
                            <FooterLink onClick={() => scrollTo('features')}>Fonctionnalités</FooterLink>
                            <FooterLink onClick={() => scrollTo('pricing')}>Tarifs</FooterLink>
                            <FooterLink onClick={() => scrollTo('faq')}>FAQ</FooterLink>
                        </FooterColumn>
                        <FooterColumn>
                            <ColumnTitle>Entreprise</ColumnTitle>
                            <FooterLink onClick={() => scrollTo('about')}>À propos</FooterLink>
                            <FooterLink href="mailto:contact@ferlo.tech">Carrières</FooterLink>
                            <FooterLink href="mailto:contact@ferlo.tech">Presse</FooterLink>
                        </FooterColumn>
                        <FooterColumn>
                            <ColumnTitle>Support</ColumnTitle>
                            <FooterLink onClick={() => scrollTo('contact')}>Centre d'aide</FooterLink>
                            <FooterLink href="mailto:contact@ferlo.tech">Nous contacter</FooterLink>
                            <FooterLink onClick={() => scrollTo('faq')}>Documentation</FooterLink>
                        </FooterColumn>
                        <FooterColumn>
                            <ColumnTitle>Contact</ColumnTitle>
                            <FooterLink>4 Rue Colonel Arnaud Beltrame</FooterLink>
                            <FooterLink>69008 - Lyon, France</FooterLink>
                            <FooterLink href="mailto:contact@ferlo.tech">contact@ferlo.tech</FooterLink>
                        </FooterColumn>
                    </FooterColumns>
                </FooterTop>

                <FooterBottom>
                    <Copyright>
                        &copy; {new Date().getFullYear()} OpenDaara. Propulsé par
                        <img src="/img/icons/logo-ferlo.png" alt="Ferlo Technology" />
                        Ferlo Technology
                    </Copyright>
                    <FooterLegal>
                        <FooterLink as="span">Mentions légales</FooterLink>
                        <FooterLink as="span">Politique de confidentialité</FooterLink>
                        <FooterLink as="span">CGU</FooterLink>
                    </FooterLegal>
                </FooterBottom>
            </FooterWrapper>
        </FooterSection>
    );
};

export default withTranslation()(Footer);
